import { Box, Link, Stack, Typography } from "@mui/material";
import { useBreakpoints } from "../../../context/provider/BreakpointsProvider";

const Footer = ({ open }) => {
  const { downSm } = useBreakpoints();
  const isMobileScreen = downSm;

  return (
    <Stack
      component="footer"
      direction="row"
      justifyContent={{ xs: "center", sm: "flex-end" }}
      ml={isMobileScreen ? 0 : open ? 60 : 27.5}
      pr={{ xs: 3, sm: 5.175 }}
      pb={6.25}
      pl={{ xs: 3, sm: 5.25 }}
    >
      <Typography
        variant="subtitle1"
        sx={{ textAlign: { xs: "center", sm: "right" } }}
      >
        All Rights Reserved{" "}
        <Link
          href="https://donaiapps.com/"
          target="_blank"
          rel="noopener"
          aria-label="Agro System Management"
          sx={{ color: "text.primary", "&:hover": { color: "primary.main" } }}
        >
          donaiApps
        </Link>
      </Typography>
    </Stack>
  );
};

export default Footer;
